export const buildContactTimelinePath = (enduserId: string): string => `/contacts/timeline/${enduserId}`;
